import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { getUniqueId } from '../../shared/utilities/utilities';


@Injectable({
  providedIn: 'root'
})
export class DocumentReviewsService {

  organization = 'test';  // e.g. demo, test, shasta, etc.
  // organization = environment.crudStage;  // e.g. demo, test, shasta, etc.
  domainForDocumentReviews = environment.domainForDocumentReviews;
  apiKey = environment.documentReviewsKeyForProd;

  private getActiveDocReviewsUrl: string = this.domainForDocumentReviews + 'get-active-doc-reviews';
  private getAllDocReviewsUrl: string = this.domainForDocumentReviews + 'get-org-doc-reviews';
  private writeNewDocReviewUrl: string = this.domainForDocumentReviews + 'new-doc-review';
  private replaceDocReviewUrl: string = this.domainForDocumentReviews + 'replace-doc-review';


  allDocumentReviews = [];

  constructor(private http: HttpClient) { }


  getDocReviewId(documentReviewData) {

    console.log('documentReviewData: ', documentReviewData);

    if (documentReviewData.id != undefined) {
      return 'v0001_' + documentReviewData.id;
    } else {
      return 'v0001_' + getUniqueId();
    }

  }


  replaceDocReview(docReviewData: any): Promise<any> {
    console.log('inside replaceDocReview');
    console.log('document review data --> ', docReviewData);

    let jsonReadyBody = {
      'object': docReviewData
    }

    let options = {
      params : {
        'site' : this.organization
      },
      headers : {
        'Content-Type' : 'application/json',
        'x-api-key': this.apiKey
      }
    };

    let body = JSON.stringify(jsonReadyBody);

    // console.log('Doc Review would have posted this: ', body);

    return this.http.post(this.replaceDocReviewUrl, body, options)
                    .toPromise()
                    .catch(this.handleError);

  } // replaceDocReview




  updateExistingDocReview(docReviewData: any): Promise<any> {
    console.log('inside updateExistingDocReview');
    console.log('document review data --> ', docReviewData);
    console.log('edit doc review: ', docReviewData.Id);
    console.log('doc review object: ', docReviewData.object);

      let jsonReadyBody = {
        'Entity_Type': 'docReview',
        'Id': docReviewData.Id,
        'status': docReviewData.status,
        'object': docReviewData.object
      }

      let options = {
        params : {
          'site' : this.organization
        },
        headers : {
          'Content-Type' : 'application/json',
          'x-api-key': this.apiKey
        }
      };

      let body = JSON.stringify(jsonReadyBody);

      // console.log('udpate doc review with: ', body);

      return this.http.post(this.writeNewDocReviewUrl, body, options)
        .toPromise()
        .catch(this.handleError);

  } // updateExistingDocReview


  writeNewDocReview(docReviewData: any): Promise<any> {
    // console.log('inside writeNewDocReview');
    // console.log('document review data --> ', docReviewData);
    // console.log('edit doc review: ', docReviewData.id);
    // console.log('doc review object: ', docReviewData.object);

      let idOfDocReview = this.getDocReviewId(docReviewData);

      if (docReviewData.id == undefined) {
        let docReviewIdArray = idOfDocReview.split('_');
        docReviewData.id = docReviewIdArray[docReviewIdArray.length - 1];
        // console.log('added doc review ID: ', docReviewData.id);
      }

      let jsonReadyBody = {
        'Entity_Type': 'docReview',
        'Id': idOfDocReview,
        'status': 'active',
        'object': docReviewData
      }

      // let jsonReadyBody = {
      //   'Id': this.getDocReviewId(docReviewData),
      //   'entityType': 'docReview',
      //   'status': 'active',
      //   'object': docReviewData
      // }

      let options = {
        params : {
          'site' : this.organization
        },
        headers : {
          'Content-Type' : 'application/json',
          'x-api-key': this.apiKey
        }
      };

      let body = JSON.stringify(jsonReadyBody);

      // console.log('update doc review with: ', body);

      return this.http.post(this.writeNewDocReviewUrl, body, options)
        .toPromise()
        .catch(this.handleError);


  } // writeNewDocReview






  getAllDocReviews(): Promise<any> {
    // console.log('inside getAllDocReviews');

    let options = {
      params : {
        'site' : this.organization
      },
      headers : {
        'Content-Type' : 'application/json',
        'x-api-key': this.apiKey
      }
    };

    return this.http.get(this.getAllDocReviewsUrl, options).toPromise();
  } // getAllDocReviews






  getActiveDocReviews(): Promise<any> {
    // console.log('inside getAllDocReviews');

    let options = {
      params : {
        'site' : this.organization
      },
      headers : {
        'Content-Type' : 'application/json',
        'x-api-key': this.apiKey
      }
    };

    return this.http.get(this.getActiveDocReviewsUrl, options).toPromise();
  } // getActiveDocReviews



  private handleError(error: any): Promise<any> {
    console.error('An error occurred ', error);
    console.error('Error in JSON ', JSON.stringify(error));
    return Promise.reject(error.message || error);
  }

}
